import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from '../../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../../lib/constants/constant';
import { DisplayDecimal, DisplayEuroMUI } from '../../../../../../../../utils/formats';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../../lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from '../../../../../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const PersonalkostenUebersichtSkizzeEmob: FC<{}> = () => {
	const { application } = useApplication();
	const columns = [
		{ field: 'id', headerName: 'ID', width: 80, groupable: false },
		{ field: 'kostraeger', headerName: 'Kostenträger', flex: 1 },
		{ field: 'unternehmen', headerName: 'Unternehmen / Institution', flex: 1, groupable: false },
		{ field: 'kostenKategorie', headerName: 'Kostenkategorie', flex: 1, groupable: false },
		{ field: 'qualifikation', headerName: 'Qualifikation', flex: 1 },
		{
			field: 'stundensatz',
			headerName: 'Stundensatz',
			flex: 1,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : null;
			},
		},
		{
			field: 'stundengeplannt',
			headerName: 'Geplante Projektstunden',
			flex: 1,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayDecimal(value) : null;
			},
		},
		{
			field: 'geplanteSumme',
			headerName: 'Geplante Summe',
			flex: 1,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : null;
			},
		},
	];

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === 'Personalkosten')
			.map((ele: any) => {
				return {
					id: get(ele, 'id'),
					kostraeger: get(ele, KP_P.Allgemein_Kostentraeger.path, ''),
					unternehmen: get(ele, KP_P.Unternehmen.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path),
					kostenKategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
					qualifikation: get(
						ele,
						KP_P.Personalausgaben_Emob_Skizze.schema.attributes.E_Mob_Skizze_Qualifikation_Funktion.path,
						'',
					),
					stundensatz: get(ele, KP_P.Personalausgaben_Emob_Skizze.schema.attributes.E_Mob_Skizze_Stundensatz.path, ''),
					stundengeplannt: get(
						ele,
						KP_P.Personalausgaben_Emob_Skizze.schema.attributes.E_Mob_Skizze_Geplante_Stunden_Im_Projekt.path,
						'',
					),
					geplanteSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		return {
			aggregation: {
				model: { stundensatz: 'sum', stundengeplannt: 'sum', geplanteSumme: 'sum' },
			},
		};
	}, []);

	return (
		<>
			<ApplicationHeading title="	Personalkosten Übersicht" description={PLATZHALTER_TEXT} />
			<DataGridPremium
				rows={rows}
				columns={columns}
				initialState={initialState}
				hideFooter
				localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
			/>
		</>
	);
};
export default PersonalkostenUebersichtSkizzeEmob;
